import React, { useState, useEffect } from "react";
import axios from "axios";
import WorkOrderTimeline from "../OwnerDashboard/Actions/WorkOrderTimeline";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  Avatar,
  Grid,
  Divider,
  CircularProgress,
  Tabs,
  Tab,
  TextField,
  Modal,
  Dialog,
  DialogContent,
  IconButton,
  Snackbar,
  Alert,
  Stack,
  Link,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InfoIcon from "@mui/icons-material/Info";
import HomeIcon from "@mui/icons-material/Home";
import DescriptionIcon from "@mui/icons-material/Description";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useParams, useNavigate } from "react-router-dom";
import Visits from "../WorkorderVisits";
import api, { API_BASE_URL } from "../../utils/api";
import CloseIcon from "@mui/icons-material/Close";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useDropzone } from "react-dropzone";
import * as MuiIcons from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import AddCommentIcon from "@mui/icons-material/AddComment";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WcIcon from "@mui/icons-material/Wc";
import PhoneIcon from "@mui/icons-material/Phone";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import EmailIcon from "@mui/icons-material/Email";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PersonIcon from "@mui/icons-material/Person";

const WorkOrdersDetails = () => {
  const { id } = useParams();
  const theme = useTheme();
  const [statuses, setStatuses] = useState([]);

  const navigate = useNavigate();
  const [workOrderDetails, setWorkOrderDetails] = useState(null);
  const [member, setMember] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [imageURL, setImageURL] = useState(null);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [commentType, setCommentType] = useState(0);
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [commentImageUrl, setCommentImageUrl] = useState(null);
  const [openCommentImageModal, setOpenCommentImageModal] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const storedUser = sessionStorage.getItem("user");
  let currentUserId = null;

  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      currentUserId = parsedUser?.userId ?? null;
    } catch (e) {
      console.error("Failed to parse user from sessionStorage", e);
    }
  }

  const pageCardSx = {
    borderRadius: "18px",
    border: "1px solid rgba(47,99,173,0.08)",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    backgroundColor: "rgba(255,255,255,0.96)",
  };

  const softCardSx = {
    borderRadius: "16px",
    border: "1px solid rgba(47,99,173,0.08)",
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
    backgroundColor: "#fff",
  };

  const softInsetSx = {
    borderRadius: "14px",
    border: "1px solid rgba(47,99,173,0.08)",
    backgroundColor: "rgba(47,99,173,0.03)",
  };

  const sectionIconWrapSx = {
    width: 36,
    height: 36,
    minWidth: 36,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(47,99,173,0.08)",
    flexShrink: 0,
  };

  const primaryButtonSx = {
    backgroundColor: "#2f63ad",
    color: "white",
    fontWeight: 700,
    borderRadius: "10px",
    textTransform: "none",
    px: 2.25,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#1f4f94",
      boxShadow: "none",
    },
  };

  const secondaryButtonSx = {
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: 600,
    px: 2,
    borderColor: "rgba(47,99,173,0.18)",
    color: "#223142",
    "&:hover": {
      borderColor: "#2f63ad",
      color: "#2f63ad",
      backgroundColor: "rgba(47,99,173,0.04)",
    },
  };

  const textFieldSx = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "rgba(255,255,255,0.96)",
      borderRadius: "10px",
    },
  };

  const dialogPaperSx = {
    borderRadius: "18px",
    background: "rgba(255,255,255,0.98)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.22)",
  };

  const infoRowSx = {
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
    py: 0.75,
    minWidth: 0,
    height: "100%",
  };

  const iconWrapSx = {
    width: 34,
    height: 34,
    minWidth: 34,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(47,99,173,0.08)",
    flexShrink: 0,
  };

  const labelSx = {
    color: "#8a94a6",
    display: "block",
    lineHeight: 1.2,
    mb: 0.25,
  };

  const valueSx = {
    color: "#223142",
    fontWeight: 600,
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    lineHeight: 1.3,
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const getLegacyCommentImageUrl = (uploadValue) => {
    if (!uploadValue) return "";
    return `${API_BASE_URL}/workorderimages/${encodeURIComponent(uploadValue)}`;
  };

  const getFormattedDate = (dateString) => {
    if (!dateString) return "N/A";
    const parsed = new Date(dateString);
    if (Number.isNaN(parsed.getTime())) return "N/A";

    return parsed.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const workOrderResp = await api.get(`/getWorkOrders/${id}`);
        const workOrderData = workOrderResp.data;

        const memberResp = await api.get(`/members/${workOrderData.property_id}`);
        const memberData = memberResp.data;

        const usersResp = await api.get(`${API_BASE_URL}/users`);
        const fetchedUsers = usersResp.data;

        const commentsResp = await api.get(`/getExternalComments/${id}`);
        const fetchedComments = commentsResp.data;

        const statusResp = await api.get(`/statuses`);
        setStatuses(statusResp.data);

        setWorkOrderDetails(workOrderData);
        setMember(memberData);
        setUsers(fetchedUsers);
        setComments(fetchedComments);

        if (workOrderData.upload_urls && workOrderData.upload_urls.trim() !== "") {
          const filename = workOrderData.upload_urls.trim();
          const sanitizedFilename = encodeURIComponent(
            filename.split(/(\\|\/)/g).pop()
          );
          const imageUrl = `${API_BASE_URL}/workorderimages/${sanitizedFilename}`;
          setImageURL(imageUrl);
        } else {
          setImageURL(null);
        }
      } catch (error) {
        console.error("Failed to fetch details:", error);
        setError("Failed to fetch details.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchDetails();
  }, [id]);

  const getStatusInfo = (statusName) => {
    return statuses.find((s) => s.statusname === statusName);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    multiple: false,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        setSelectedFile(file);
        setFilePreview(URL.createObjectURL(file));
      }
    },
  });

  const handleAddComment = async () => {
    if (!newComment.trim()) {
      showSnackbar("Comment cannot be empty.", "warning");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("work_order_id", id);
      formData.append("user_id", currentUserId);
      formData.append("comment_text", newComment);
      formData.append("is_internal", 0);

      if (selectedFile) {
        formData.append("upload_urls", selectedFile);
      }

      const response = await api.post(`/addComment`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setComments((prevComments) => [
        {
          comment_id: response.data.comment_id,
          comment_text: newComment,
          sent_at: response.data.sent_at || new Date().toISOString(),
          is_internal: commentType === "internal" ? 1 : 0,
          user_name: "You",
          user_lastname: "",
          upload_urls: selectedFile ? selectedFile.name : null,
        },
        ...prevComments,
      ]);

      setNewComment("");
      setCommentType("external");
      setSelectedFile(null);
      setFilePreview(null);
      setIsCommentModalOpen(false);

      showSnackbar("Comment added successfully!", "success");
    } catch (error) {
      console.error("Failed to add comment:", error);
      showSnackbar("Failed to add comment. Please try again.", "error");
    }
  };

  const calculateDaysOpen = (createdAt) => {
    if (!createdAt) return "N/A";

    const createdDate = new Date(createdAt);
    const today = new Date();
    const diffTime = Math.abs(today - createdDate);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const SectionTitle = ({ icon, title, subtitle, action }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
        flexWrap: "wrap",
        mb: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
        <Box sx={sectionIconWrapSx}>{icon}</Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, color: "#223142", lineHeight: 1.2 }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ color: "#6b778c", mt: 0.3 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {action}
    </Box>
  );
const DetailCard = ({
  icon,
  label,
  value,
  chip = null,
  minHeight = 88,
  fullHeight = true,
  compact = false,
}) => (
  <Card
    sx={{
      ...softCardSx,
      p: compact ? 1.5 : 2,
      minHeight,
      height: fullHeight ? "100%" : "auto",
      display: "flex",
      alignItems: "flex-start",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.1, width: "100%" }}>
      <Box
        sx={{
          ...sectionIconWrapSx,
          width: compact ? 32 : 36,
          height: compact ? 32 : 36,
          minWidth: compact ? 32 : 36,
          borderRadius: compact ? "9px" : "10px",
          mt: 0.15,
        }}
      >
        {icon}
      </Box>

      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant="caption"
          sx={{
            color: "#8a94a6",
            display: "block",
            mb: 0.35,
            fontSize: compact ? "0.74rem" : "0.78rem",
            letterSpacing: "0.02em",
            lineHeight: 1.1,
          }}
        >
          {label}
        </Typography>

        {chip ? (
          chip
        ) : (
          <Typography
            variant="body1"
            sx={{
              color: "#223142",
              fontWeight: 700,
              lineHeight: compact ? 1.3 : 1.45,
              wordBreak: "break-word",
              overflowWrap: "anywhere",
              whiteSpace: "pre-wrap",
              fontSize: compact ? "0.98rem" : "1rem",
            }}
          >
            {value || "N/A"}
          </Typography>
        )}
      </Box>
    </Box>
  </Card>
);

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: "50vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" sx={{ textAlign: "center", mt: 4 }}>
        {error}
      </Typography>
    );
  }

  const memberPhotoUrl = `${API_BASE_URL}/images/${encodeURIComponent(
    member?.PhotoGraphicFileName?.trim() || ""
  )}`;

  const address = member?.FullAddress?.trim() || "N/A";
  const mapsLink =
    address !== "N/A"
      ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
      : null;

  const phone = member?.PhoneNumber?.trim() || null;
  const altPhone = member?.AlternatePhoneNumber?.trim() || null;
  const cellPhone = member?.CellPhoneNumber?.trim() || null;
  const email = member?.EmailAddress?.trim() || null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ ...secondaryButtonSx, mb: 3 }}
        >
          Back
        </Button>

        <Grid container spacing={3}>
          {member && (
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Card sx={{ ...pageCardSx, overflow: "hidden" }}>
                  <Box
                    sx={{
                      px: 2.5,
                      pt: 2.5,
                      pb: 2,
                      borderBottom: "1px solid rgba(47,99,173,0.08)",
                      backgroundColor: "rgba(47,99,173,0.02)",
                      textAlign: "center",
                    }}
                  >
                    <Avatar
                      src={memberPhotoUrl}
                      alt={member?.FirstName}
                      sx={{
                        width: 112,
                        height: 112,
                        margin: "0 auto",
                        mb: 1.75,
                        border: "4px solid rgba(47,99,173,0.16)",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                      }}
                    />

                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: "#223142",
                        lineHeight: 1.2,
                      }}
                    >
                      {`${member?.FirstName || ""} ${member?.LastName || ""}`.trim() ||
                        "Member"}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        color: "#6b778c",
                        mt: 0.5,
                      }}
                    >
                      Member Code: {member?.ClubMemberCode || "N/A"}
                    </Typography>

                    <Box sx={{ mt: 1.5 }}>
                      <Chip
                        label={member?.ClubStatusRuleCode || "Unknown"}
                        color="success"
                        size="small"
                        icon={<VerifiedUserIcon sx={{ color: "white !important" }} />}
                        sx={{
                          fontWeight: 700,
                          height: 30,
                          borderRadius: "999px",
                        }}
                      />
                    </Box>
                  </Box>

                  <Box sx={{ p: 2.5 }}>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <PersonIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Member
                            </Typography>
                            <Typography variant="body2" sx={valueSx}>
                              {member?.ClubMemberCode || "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <WcIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Gender
                            </Typography>
                            <Typography variant="body2" sx={valueSx}>
                              {member?.Gender || "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <CalendarTodayIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Birth Date
                            </Typography>
                            <Typography variant="body2" sx={valueSx}>
                              {getFormattedDate(member?.BirthDate)}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <CalendarTodayIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Join Date
                            </Typography>
                            <Typography variant="body2" sx={valueSx}>
                              {getFormattedDate(member?.JoinDate)}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <PhoneIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Phone
                            </Typography>
                            {phone ? (
                              <Link
                                href={`tel:${phone}`}
                                underline="hover"
                                sx={{
                                  color: "#2f63ad",
                                  fontSize: "0.95rem",
                                  fontWeight: 600,
                                  wordBreak: "break-word",
                                }}
                              >
                                {phone}
                              </Link>
                            ) : (
                              <Typography variant="body2" sx={valueSx}>
                                N/A
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <ContactPhoneIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Alt Phone
                            </Typography>
                            {altPhone ? (
                              <Link
                                href={`tel:${altPhone}`}
                                underline="hover"
                                sx={{
                                  color: "#2f63ad",
                                  fontSize: "0.95rem",
                                  fontWeight: 600,
                                  wordBreak: "break-word",
                                }}
                              >
                                {altPhone}
                              </Link>
                            ) : (
                              <Typography variant="body2" sx={valueSx}>
                                N/A
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <SmartphoneIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Cell
                            </Typography>
                            {cellPhone ? (
                              <Link
                                href={`tel:${cellPhone}`}
                                underline="hover"
                                sx={{
                                  color: "#2f63ad",
                                  fontSize: "0.95rem",
                                  fontWeight: 600,
                                  wordBreak: "break-word",
                                }}
                              >
                                {cellPhone}
                              </Link>
                            ) : (
                              <Typography variant="body2" sx={valueSx}>
                                N/A
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <EmailIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Email
                            </Typography>
                            {email ? (
                              <Link
                                href={`mailto:${email}`}
                                underline="hover"
                                sx={{
                                  color: "#2f63ad",
                                  fontSize: "0.95rem",
                                  fontWeight: 600,
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere",
                                }}
                              >
                                {email}
                              </Link>
                            ) : (
                              <Typography variant="body2" sx={valueSx}>
                                N/A
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <HomeIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Address
                            </Typography>
                            {mapsLink ? (
                              <Link
                                href={mapsLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                                sx={{
                                  color: "#2f63ad",
                                  fontSize: "0.95rem",
                                  fontWeight: 600,
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere",
                                }}
                              >
                                {address}
                              </Link>
                            ) : (
                              <Typography variant="body2" sx={valueSx}>
                                N/A
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Card>

                <Card sx={{ ...pageCardSx, overflow: "hidden" }}>
                  <Box
                    sx={{
                      px: 2.5,
                      pt: 2.25,
                      pb: 1.5,
                      borderBottom: "1px solid rgba(47,99,173,0.08)",
                      backgroundColor: "rgba(47,99,173,0.02)",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 700, color: "#223142" }}
                    >
                      Activity Timeline
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#6b778c", mt: 0.4 }}>
                      Work order activity, comments, events, and notifications.
                    </Typography>
                  </Box>

                  <Box sx={{ p: 2.5 }}>
                    <Box
                      sx={{
                        borderRadius: "14px",
                        border: "1px solid rgba(47,99,173,0.08)",
                        backgroundColor: "rgba(47,99,173,0.02)",
                        p: 1.5,
                      }}
                    >
                      <WorkOrderTimeline workOrderId={workOrderDetails.order_id} />
                    </Box>
                  </Box>
                </Card>
              </Box>
            </Grid>
          )}

          <Grid item xs={12} md={8}>
            <Card sx={{ ...pageCardSx, overflow: "hidden" }}>
              <Box
                sx={{
                  px: { xs: 2, sm: 2.5, md: 3 },
                  pt: 2.5,
                  pb: 2,
                  borderBottom: "1px solid rgba(47,99,173,0.08)",
                  backgroundColor: "rgba(47,99,173,0.02)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: { xs: "flex-start", sm: "center" },
                    flexDirection: { xs: "column", sm: "row" },
                    gap: 1.25,
                  }}
                >
                  <Box>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: "#223142" }}>
                      Work Order Details
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#6b778c", mt: 0.5 }}>
                      Review work order information, comments, and visits.
                    </Typography>
                  </Box>

                  <Chip
                    label={`Opened ${calculateDaysOpen(workOrderDetails?.created_at)} days ago`}
                    sx={{
                      borderRadius: "999px",
                      fontWeight: 700,
                      backgroundColor: "rgba(47,99,173,0.10)",
                      color: "#2f63ad",
                    }}
                  />
                </Box>

                <Typography variant="body2" sx={{ color: "#6b778c", mt: 1.5 }}>
                  Work Order ID: <strong>WO-{workOrderDetails?.order_id}</strong>
                </Typography>
              </Box>

              <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  variant="fullWidth"
                  sx={{
                    mb: 3,
                    minHeight: 44,
                    backgroundColor: "rgba(47,99,173,0.03)",
                    borderRadius: "12px",
                    p: 0.5,
                    "& .MuiTabs-indicator": { display: "none" },
                    "& .MuiTab-root": {
                      minHeight: 40,
                      textTransform: "none",
                      fontWeight: 700,
                      borderRadius: "10px",
                      color: "#6b778c",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#fff",
                      color: "#223142 !important",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    },
                  }}
                >
                  <Tab label="Details" />
                  <Tab label="Comments" />
                  <Tab label="Visits" />
                </Tabs>

               {activeTab === 0 && (
  <Box
  sx={{
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
    gap: 1.5,
    alignItems: "start",
  }}
>
  <DetailCard
    icon={<InfoIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
    label="Work Order ID"
    value={
      workOrderDetails?.order_id
        ? `WO-${workOrderDetails.order_id}`
        : "N/A"
    }
    minHeight={74}
    compact
  />

  <DetailCard
    icon={<HomeIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
    label="Property ID"
    value={workOrderDetails.property_id || "N/A"}
    minHeight={74}
    compact
  />

  <Box sx={{ gridColumn: "1 / -1" }}>
    <DetailCard
      icon={<DescriptionIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
      label="Description"
      value={workOrderDetails.description || "No Description Available"}
      minHeight={84}
      fullHeight={false}
    />
  </Box>

  <Box sx={{ gridColumn: "1 / -1" }}>
    <DetailCard
      icon={<ListAltIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
      label="Details"
      value={workOrderDetails.details || "No Details Available"}
      minHeight={96}
      fullHeight={false}
    />
  </Box>

  <DetailCard
    icon={<CalendarTodayIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
    label="Created"
    value={
      workOrderDetails.created_at
        ? new Date(workOrderDetails.created_at).toLocaleString()
        : "N/A"
    }
    minHeight={84}
  />

  <Card
    sx={{
      ...softCardSx,
      p: 1.75,
      minHeight: 84,
      display: "flex",
      alignItems: "flex-start",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.1, width: "100%" }}>
      <Box
        sx={{
          ...sectionIconWrapSx,
          width: 32,
          height: 32,
          minWidth: 32,
          borderRadius: "9px",
          mt: 0.15,
        }}
      >
        {(() => {
          const statusInfo = getStatusInfo(workOrderDetails.status);
          const IconComponent = statusInfo?.icon && MuiIcons[statusInfo.icon];
          const color =
            theme.palette[statusInfo?.color]?.main ||
            (statusInfo?.color === "grey" ? theme.palette.grey[500] : statusInfo?.color) ||
            "#64748b";

          return IconComponent ? (
            <IconComponent fontSize="small" sx={{ color }} />
          ) : (
            <MuiIcons.InfoOutlined fontSize="small" sx={{ color: "#2f63ad" }} />
          );
        })()}
      </Box>

      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant="caption"
          sx={{
            color: "#8a94a6",
            display: "block",
            mb: 0.35,
            fontSize: "0.74rem",
            letterSpacing: "0.02em",
            lineHeight: 1.1,
          }}
        >
          Status
        </Typography>

        {(() => {
          const statusInfo = getStatusInfo(workOrderDetails.status);
          const color =
            theme.palette[statusInfo?.color]?.main ||
            (statusInfo?.color === "grey" ? theme.palette.grey[500] : statusInfo?.color) ||
            "#64748b";

          return (
            <Chip
              label={statusInfo?.statusname || "Unknown"}
              size="small"
              sx={{
                borderRadius: "999px",
                backgroundColor: color,
                color: "#fff",
                fontWeight: 700,
                height: 28,
              }}
            />
          );
        })()}
      </Box>
    </Box>
  </Card>
</Box>
)}

                {activeTab === 2 && (
                  <Card sx={{ ...softCardSx, overflow: "hidden" }}>
                    <Box
                      sx={{
                        px: 2.5,
                        pt: 2.25,
                        pb: 1.5,
                        borderBottom: "1px solid rgba(47,99,173,0.08)",
                        backgroundColor: "rgba(47,99,173,0.02)",
                      }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: 700, color: "#223142" }}>
                        Visits
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#6b778c", mt: 0.4 }}>
                        Scheduled and completed visits for this work order.
                      </Typography>
                    </Box>

                    <Box sx={{ p: 2.5 }}>
                      <Visits work_order_id={id} currentUserId={currentUserId} />
                    </Box>
                  </Card>
                )}

                {activeTab === 1 && (
                  <Box>
                    <Card sx={{ ...pageCardSx, overflow: "hidden" }}>
                      <Box
                        sx={{
                          px: { xs: 1.5, sm: 2, md: 3 },
                          pt: 2.25,
                          pb: 1.5,
                          borderBottom: "1px solid rgba(47,99,173,0.08)",
                          backgroundColor: "rgba(47,99,173,0.02)",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                          <ChatBubbleOutlineIcon sx={{ color: "#2f63ad" }} />
                          <Typography variant="h6" sx={{ fontWeight: 700, color: "#223142" }}>
                            Comments
                          </Typography>
                        </Box>

                        <Typography variant="body2" sx={{ color: "#6b778c" }}>
                          Review comment history and attachments.
                        </Typography>
                      </Box>

                      <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mb: 2.5,
                          }}
                        >
                          <Button
                            variant="contained"
                            startIcon={<AddCommentIcon />}
                            onClick={() => setIsCommentModalOpen(true)}
                            sx={primaryButtonSx}
                          >
                            Add Comment
                          </Button>
                        </Box>

                        {comments.length > 0 ? (
                          <Stack spacing={2}>
                            {comments.map((comment) => {
                              const imageSrc = comment.upload_urls
                                ? getLegacyCommentImageUrl(comment.upload_urls)
                                : null;

                              return (
                                <Card
                                  key={comment.comment_id}
                                  sx={{
                                    borderRadius: "16px",
                                    border: "1px solid rgba(47,99,173,0.08)",
                                    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
                                    backgroundColor: "#fff",
                                    overflow: "hidden",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      px: 2,
                                      py: 1.5,
                                      borderBottom: "1px solid rgba(47,99,173,0.08)",
                                      backgroundColor: "rgba(47,99,173,0.05)",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      gap: 1.5,
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <Chip
                                      label="External Comment"
                                      size="small"
                                      sx={{
                                        fontWeight: 700,
                                        borderRadius: "999px",
                                        color: "#1d4ed8",
                                        backgroundColor: "rgba(59,130,246,0.12)",
                                      }}
                                    />
                                  </Box>

                                  <Box sx={{ p: 2 }}>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#223142",
                                        whiteSpace: "pre-wrap",
                                        mb: imageSrc ? 1.25 : 0,
                                      }}
                                    >
                                      {comment.comment_text}
                                    </Typography>

                                    {imageSrc && (
                                      <Box sx={{ mt: 1.25 }}>
                                        <Typography
                                          variant="body2"
                                          sx={{ fontWeight: 700, color: "#223142", mb: 1 }}
                                        >
                                          Attachment
                                        </Typography>

                                        <Card
                                          sx={{
                                            ...softInsetSx,
                                            p: 2,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            gap: 1,
                                            textAlign: "center",
                                            maxWidth: 260,
                                            backgroundColor: "#fff",
                                          }}
                                        >
                                          <Box
                                            component="img"
                                            src={imageSrc}
                                            alt="Comment Attachment"
                                            sx={{
                                              maxWidth: "100%",
                                              maxHeight: 120,
                                              borderRadius: "8px",
                                              cursor: "pointer",
                                              objectFit: "cover",
                                            }}
                                            onClick={() => {
                                              setCommentImageUrl(imageSrc);
                                              setOpenCommentImageModal(true);
                                            }}
                                          />

                                          <Typography
                                            variant="body2"
                                            sx={{ mt: 0.5, wordBreak: "break-word" }}
                                          >
                                            Attachment Preview
                                          </Typography>

                                          <Box
                                            sx={{
                                              mt: 1,
                                              display: "flex",
                                              gap: 1,
                                              flexWrap: "wrap",
                                            }}
                                          >
                                            <Button
                                              size="small"
                                              variant="outlined"
                                              startIcon={<VisibilityIcon />}
                                              onClick={() => {
                                                setCommentImageUrl(imageSrc);
                                                setOpenCommentImageModal(true);
                                              }}
                                              sx={secondaryButtonSx}
                                            >
                                              Preview
                                            </Button>
                                          </Box>
                                        </Card>
                                      </Box>
                                    )}

                                    <Divider
                                      sx={{ my: 1.5, borderColor: "rgba(47,99,173,0.08)" }}
                                    />

                                    <Typography
                                      variant="caption"
                                      sx={{
                                        color: "#6b778c",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 0.5,
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <AccessTimeIcon sx={{ fontSize: 14 }} />
                                      Added by {comment.user_name} {comment.user_lastname || ""} on{" "}
                                      {new Date(comment.sent_at).toLocaleString()}
                                    </Typography>
                                  </Box>
                                </Card>
                              );
                            })}
                          </Stack>
                        ) : (
                          <Card sx={{ ...pageCardSx, p: 3, textAlign: "center" }}>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 600, color: "#223142" }}
                            >
                              No comments available
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ color: "#6b778c", mt: 0.75 }}
                            >
                              Add the first comment for this work order.
                            </Typography>

                            <Box sx={{ mt: 2 }}>
                              <Button
                                variant="contained"
                                startIcon={<AddCommentIcon />}
                                onClick={() => setIsCommentModalOpen(true)}
                                sx={primaryButtonSx}
                              >
                                Add Comment
                              </Button>
                            </Box>
                          </Card>
                        )}
                      </Box>
                    </Card>
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>

        <Modal open={isCommentModalOpen} onClose={() => setIsCommentModalOpen(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "92%", sm: 520 },
              maxHeight: "90vh",
              overflowY: "auto",
              backgroundColor: "rgba(255,255,255,0.98)",
              padding: 0,
              borderRadius: "18px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.22)",
              border: "1px solid rgba(47,99,173,0.08)",
            }}
          >
            <Box
              sx={{
                px: 3,
                pt: 2.5,
                pb: 1.5,
                borderBottom: "1px solid rgba(47,99,173,0.08)",
                backgroundColor: "rgba(47,99,173,0.02)",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 700, color: "#223142" }}>
                Add Comment
              </Typography>
              <Typography variant="body2" sx={{ color: "#6b778c", mt: 0.5 }}>
                Add a comment and optionally attach an image.
              </Typography>
            </Box>

            <Box sx={{ p: 3 }}>
              <TextField
                fullWidth
                label="Comment"
                multiline
                rows={3}
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                sx={{ ...textFieldSx, mb: 2 }}
              />

              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, fontWeight: 600, color: "#223142" }}
                >
                  Attach Image
                </Typography>

                <Box
                  {...getRootProps()}
                  sx={{
                    ...softInsetSx,
                    p: 2.5,
                    textAlign: "center",
                    cursor: "pointer",
                    borderStyle: "dashed",
                    borderWidth: "2px",
                  }}
                >
                  <input {...getInputProps()} />
                  <CloudUploadIcon sx={{ fontSize: 40, color: "#1976d2", mb: 1 }} />
                  <Typography variant="body2" sx={{ color: "#6b778c" }}>
                    Drag & drop an image, or click to select
                  </Typography>
                </Box>
              </Box>

              {filePreview && (
                <Box sx={{ textAlign: "center", mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1, color: "#223142" }}>
                    Preview
                  </Typography>
                  <img
                    src={filePreview}
                    alt="Preview"
                    style={{ maxWidth: "100%", maxHeight: 150, borderRadius: 8 }}
                  />
                </Box>
              )}

              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.25 }}>
                <Button
                  variant="outlined"
                  onClick={() => setIsCommentModalOpen(false)}
                  sx={secondaryButtonSx}
                >
                  Cancel
                </Button>

                <Button variant="contained" onClick={handleAddComment} sx={primaryButtonSx}>
                  Save Comment
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>

        <Dialog
          open={openCommentImageModal}
          onClose={() => setOpenCommentImageModal(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{ sx: dialogPaperSx }}
        >
          <DialogContent
            sx={{
              position: "relative",
              backgroundColor: "#111",
              p: 2,
              textAlign: "center",
            }}
          >
            <IconButton
              onClick={() => setOpenCommentImageModal(false)}
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 1,
                bgcolor: "rgba(0,0,0,0.45)",
                "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>

            <Box
              component="img"
              src={commentImageUrl}
              alt="Comment Preview"
              sx={{
                maxWidth: "100%",
                maxHeight: "85vh",
                objectFit: "contain",
                borderRadius: "10px",
              }}
            />
          </DialogContent>
        </Dialog>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            severity={snackbar.severity}
            variant="filled"
            sx={{ borderRadius: 3 }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </LocalizationProvider>
  );
};

export default WorkOrdersDetails;